export default __webpack_public_path__ + "static/media/travellers_Pay_company.46ea5c27.jpg";